import { render, staticRenderFns } from "./veBaseBanjiBzr.vue?vue&type=template&id=fbdd9d1c&scoped=true"
import script from "./veBaseBanjiBzr.vue?vue&type=script&lang=js"
export * from "./veBaseBanjiBzr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdd9d1c",
  null
  
)

export default component.exports